import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import Amplitude from '../../utils/amplitudeHelper'
import LoadIcon from '../LoadIcon'
import { muteMusic, unmuteMusic } from '../../ducks/layout'
import { useDispatch } from 'react-redux'

const StyledModal = styled(Modal)`
  .modal-content {
    background: transparent;
    border: none;
  }
  .modal-header > .close {
    padding: 0;
    font-size: 3em;
    margin-right: -7.5%;
  }
  .modal-header {
    border: none;
  }
  .iframe-container {
    background: black;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .video-title, .video-form {
    background: #FFD421;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    width: 100%;
    border: none;
    padding: 0;
    padding-bottom: 4px;
  }
  .video-form {
    text-decoration: none;
    color: black;
  }
`

export default function VideoOnDemandModal({ cat, videoOpen, setVideoOpen, content, showTitle }) {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  useEffect(() => {
    setLoading(true)
  }, [videoOpen])

  const openForm = () => {
    Amplitude.clickVODForm(cat, content.title)
    // window.open(content.form, '_blank')
  }

  return (
    <StyledModal
      show={videoOpen}
      onHide={()=>setVideoOpen(false)}
      size="lg"
      aria-labelledby="vod-modal"
      centered
    > 
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="p-0">
        {
          showTitle &&
          <>
            <div className="video-title">{content.topic}</div>
            <div className="video-title">{content.speaker}</div>
            <div className="video-title">{content.country}</div>
          </>
        }
        <div className="iframe-container" >
          {loading && <LoadIcon />}
          <iframe
            width="100%"
            height="100%"
            title={content.title}
            src={`${content.link}?autoplay=1`}
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
            allowtransparency="true"
            frameBorder="0"
            onLoad={() => {
              setLoading(false)
            }}
          />
        </div>
        { showTitle && <a href={`mailto:${content.form}`} className="video-form d-block py-2" onClick={openForm}>Submit Your Question</a>}
      </Modal.Body>
    </StyledModal>
  )
}
